import { render, staticRenderFns } from "./ZeroState.vue?vue&type=template&id=2858a2b9&scoped=true"
import script from "./ZeroState.vue?vue&type=script&lang=js"
export * from "./ZeroState.vue?vue&type=script&lang=js"
import style0 from "./ZeroState.vue?vue&type=style&index=0&id=2858a2b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858a2b9",
  null
  
)

export default component.exports